import Api from '@/api/account-api'
import ValidationErrorHandler from '@/common/validation-error-handler'

const getOrders = async (context, payload) => {
  var result = await Api.getOrderForUser(payload.page);
  if (result) {
    context.commit('ORDERS_RECEIVED', result);
  }
}

const getUserData = async (context) => {
  let user = await Api.getUser();
  context.commit('USER_DATA_RECEIVED', user);
}

const updateUserData = async (context, payload) => {
  try {
    let user = await Api.updateUser(payload);
    context.commit('USER_DATA_RECEIVED', user);
    return { success: true }
  } catch (e) {
    let validationError = ValidationErrorHandler.handle(e);
    if (validationError.handled) {
      return { success: false, errors: validationError.errors };
    }
    let success = { success: false, errors: [] }
    return success;
  }

}

const changePassword = async (context, payload) => {
  let result = await Api.changeUserPassword(payload.old, payload.new);
  return result;
}

const resetPassword = async (context, payload) => {
  try {
    let result = await Api.resetPassword(payload.email, payload.token, payload.password);
    return result;
  } catch(e){
    let validationError = ValidationErrorHandler.handle(e);
    if (validationError.handled) {
      return { success: false, errors: validationError.errors };
    }
    return { success: false, errors: [] }
  }

}


export default {
  getOrders,
  getUserData,
  updateUserData,
  changePassword,
  resetPassword
}